import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const SmlouvaTisk = lazy(() =>
  import('@/modules/ojeta-vozidla/SmlouvaTisk').then((m) => ({ default: m.SmlouvaTisk })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/ojeta-vozidla/smlouvy/$id/tisk',
  component: () => (
    <Suspense fallback={null}>
      <SmlouvaTisk />
    </Suspense>
  ),
});
